<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <p @click="$router.go(-1)" class="back">back</p>
      <md-card>
        <md-card-content v-if="cannabis" class="md-layout md-gutter">
          <div class="md-layout-item md-size-100">
            <md-field>
              <label>Flavor Name</label>
              <md-input v-model="cannabis.name" type="text"></md-input>
              <span class="md-helper-text">Required</span>
            </md-field>
          </div>
          <div class="md-layout-item md-size-100">
            <CKEditor
              @updateData="updateData"
              label="Description"
              :inputData="cannabis.description"
            />
          </div>
          <div class="md-layout-item md-size-100">
            <label>Image</label>
            <Upload
              @remove-image="cannabis.image = null"
              :media="cannabis.image"
              @uploadImage="uploadImage"
            />
          </div>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <md-button class="md-primary md-round md-small" @click="validate">Save</md-button>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import Fuse from "fuse.js";
import { db } from "@/config/firebaseInit";
import Swal from "sweetalert2";
import Upload from "@/components/Inputs/Upload.vue";
import CKEditor from "@/components/CKEditor.vue";

export default {
  components: {
    Upload,
    CKEditor
  },
  data() {
    return {
      cannabis: {
        name: null,
        slug: null,
        image: null,
        description: null
      },
      locations: [],
      locationCalled: false,
      loc: null
    };
  },

  watch: {
    cannabis: {
      handler(val) {
        if (val.name) {
          this.cannabis.slug = this.cannabis.name
            .replace(/[^a-zA-Z0-9]/g, "-")
            .toLowerCase();
        }
      },
      deep: true
    }
  },
  created() {
    let cannabisId = this.$route.params.cannabis_id;
    let cannabisTemplate = Object.assign({}, this.cannabis);

    this.$bind("cannabis", db.collection("cannabis").doc(cannabisId)).then(
      () => {
        if (!this.cannabis) {
          this.cannabis = cannabisTemplate;
        }
      }
    );
  },
  methods: {
    validate() {
      let valid = true;
      for (let k in this.cannabis) {
        if (k !== "created" && k !== "clicks")
          if (!this.cannabis[k]) {
            valid = false;
          }
      }

      if (valid) {
        this.save();
      } else {
        return Swal.fire("Missing Fields", "Please enter all required fields");
      }
    },
    save() {
      let vm = this;
      if (this.cannabis && !this.cannabis.created) {
        this.cannabis.created = Date.now();
        this.cannabis.clicks = 0;
      }

      return db
        .collection("cannabis")
        .doc(this.$route.params.cannabis_id)
        .set(vm.cannabis, { merge: true })
        .then(() => {
          Swal.fire("Success", "Page Updated", "success").then(() => {
            this.$router.push("/flavors");
          });
        });
    },
    uploadImage(link) {
      this.cannabis.image = link;
    },
    updateData(data) {
      this.cannabis.description = data;
    }
  }
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
